module.exports = __webpack_public_path__ + "img/3.c6f6843.png";